import { IMDSDialogProps } from "./dialog.types";
import { StyledDialog } from "./dialog.style";

export const MDSDialog = (props: IMDSDialogProps) => {
  return <StyledDialog {...props} />;
};
